// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormHelperText,
    Typography,
    Divider,
    IconButton,
    Tooltip,
    Fab,
    Autocomplete
} from '@mui/material'

import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../icon';
import apiUrl from '../../configs/constant';
import MsiDatagrid from '../custom/MsiDatagridAuto';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { Controller, useForm } from 'react-hook-form'
import { useToast } from '../ToastProvider'
import { getDoctag, getGudang } from '../../api/helper'
import appInfo from '../../configs/app-info'

interface Props {
    mmgudangId?: number | string | null;
}
export default function Index({ mmgudangId }: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const token = userData.token

    const { showToast, hideToast } = useToast();

    // ** State
    const [tabs, setTabs] = useState<string>("0")
    const [tabsDetail, setTabsDetail] = useState<string>("0")
    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [valGudang, setValGudang] = useState<any>(null)
    const [valGudangTujuan, setValGudangTujuan] = useState<any>(null)
    const [valGudangTujuanKirim, setValGudangTujuanKirim] = useState<any>(null)
    const [listGudang, setListGudang] = useState<any[]>([])

    const [listData, setListData] = useState<any[]>([])
    const [listDataKirim, setListDataKirim] = useState<any[]>([])
    const [listDataTerima, setListDataTerima] = useState<any[]>([])
    const [loadingData, setLoadingData] = useState<boolean>(false)
    const [loadingKirim, setLoadingKirim] = useState<boolean>(false)
    const [loadingTerima, setLoadingTerima] = useState<boolean>(false)
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [openDialogKirim, setOpenDialogKirim] = useState<boolean>(false)
    const [isGudang17, setIsGudang17] = useState<boolean>(false)

    const arrGudang = ['12510000004', '12510000006']

    useEffect(() => {
        const gudang17 = arrGudang.includes(String(mmgudangId))
        setIsGudang17(gudang17)
        if (gudang17) {
            setValGudangTujuanKirim({
                "id": 12510000008,
                "nama": "Gudang Transit ke Rangkah"
            })
            setValue('mmgudang_tujuan_id', 12510000008)
        } else {
            setValGudangTujuanKirim({
                "id": 12510000007,
                "nama": "Gudang Transit ke 17"
            })
            setValue('mmgudang_tujuan_id', 12510000007)
        }

        const fetchDoctag = async () => {
            const response = await getDoctag(appInfo.menuId.transferStok, cabang, token);
            if (response.length > 0 && response.length === 1) {
                setValDoctag(response[0].nama)
                setValue('sysdoctag_id', response[0].id)
            }
            setListDoctag(response);
        };
        const fetchGudang = async () => {
            const response = await getGudang(token);
            response.forEach((element: any) => {
                if (String(element.id) === mmgudangId) {
                    setValGudang(element)
                    setValue('mmgudang_asal_id', element.id)
                }
            });
            const excludedIds = new Set(['12510000006', '12510000007', '12510000008']);
            const filteredResponse = response.filter((item: any) => !excludedIds.has(String(item.id)));
            setListGudang(filteredResponse);
        };
        fetchDoctag();
        fetchGudang();
        getData(tabs)

    }, [mmgudangId])

    const navigate = useNavigate();

    const getData = (mode: any) => {
        setLoadingData(true)

        let url = apiUrl.apiUrl + '/mm/transfer-stok/list-transfer-gudang'

        axios
            .get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir,
                    sysdoctag_id: null,
                    mode: mode,
                    mmgudang_id: mmgudangId
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(error => showToast(error.response?.data?.message || error.message, 'error'))
            .finally(() => setLoadingData(false))
    }

    const getKirimGudang = () => {
        setLoadingKirim(true)

        let url = apiUrl.apiUrl + '/mm/transfer-stok/list-kirim-gudang'

        axios
            .get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir,
                    mmgudang_id: mmgudangId
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data
                    if (isGudang17 == true) {
                        setListDataKirim(data.data_17)
                    } else {
                        setListDataKirim(data.data_rangkah)
                    }
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(error => showToast(error.response?.data?.message || error.message, 'error'))
            .finally(() => setLoadingKirim(false))
    }

    const getTerimaGudang = () => {
        setLoadingTerima(true)

        let url = apiUrl.apiUrl + '/mm/transfer-stok/list-terima-gudang'

        axios
            .get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir,
                    mmgudang_id: mmgudangId
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data
                    if (isGudang17 == true) {
                        setListDataTerima(data.data_17)
                    } else {
                        setListDataTerima(data.data_rangkah)
                    }
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(error => showToast(error.response?.data?.message || error.message, 'error'))
            .finally(() => setLoadingTerima(false))
    }

    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/mm/transfer-stok/delete/' + row.id
                axios
                    .delete(url, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    .then(response => {
                        if (response.data.success) {
                            showToast(response.data.message, 'success');
                            getData(tabs)
                        } else {
                            showToast(response.data.message, 'error');
                        }
                    })
                    .catch(error => {
                        showToast(error.message, 'error');
                    })
            }
        })
    };


    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        tgl: any,
        mmgudang_asal_id: any,
        mmgudang_tujuan_id: any,
        keterangan: any,
        pic: any
    }

    const defaultValues = {
        syscabang_id: cabang,
        tgl: new Date(new Date().getTime() + (7 * 60 * 60 * 1000)).toISOString().substring(0, 16),
    }

    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const ActionButtons = ({ row, onDelete, onNavigate }: {
        row: any;
        onDelete: (row: any) => void;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row.id)
            },
            {
                title: "Print",
                icon: "mdi:printer",
                color: "primary",
                onClick: () => window.open(apiUrl.baseUrl + '/mm/transfer-stock/preview/' + row.id, '_blank')
            },
            {
                title: "Hapus Sales Order",
                icon: "mdi:trash",
                color: "primary",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const ActionButtonsTerima = ({ row, onActions }: {
        row: any;
        onActions: (row: any) => void;
    }) => {
        const actions = [
            {
                title: "Terima Barang",
                icon: "mdi:check-circle",
                color: "red",
                onClick: () => onActions(row)
            },
            {
                title: "Print",
                icon: "mdi:printer",
                color: "primary",
                onClick: () => window.open(apiUrl.baseUrl + '/mm/transfer-stock/preview/' + row.id, '_blank')
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <Button
                            variant='contained'
                            startIcon={<Icon icon={action.icon} />}
                            onClick={action.onClick}
                        >
                            {action.title}
                        </Button>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(id) => navigate('/mm/transfer-stok/detail/' + id)}
                />
            ),
        },
    ];

    const actionDataTerima = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtonsTerima
                    row={row}
                    onActions={handleTerima}
                />
            ),
        },
    ];

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getData(newValue)
    }
    const handleChangeTabsDetail = (event: SyntheticEvent, newValue: string) => {
        setTabsDetail(newValue)
    }

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue ? newValue.id : null)
        setValDoctag(newValue.nama)
    }
    const handleChangeAutocompleteGudang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_asal_id', newValue ? newValue.id : null)
        setValGudang(newValue);
    }
    const handleChangeAutocompleteGudangTujuan = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_tujuan_id', newValue ? newValue.id : null)
        setValGudangTujuan(newValue);
    }

    const onSubmit = (data: any) => {
        setOpenDialog(false)
        setOpenDialogKirim(false)
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/mm/transfer-stok/add'
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.close();
                            showToast(response.data.message, 'success');
                            navigate('/mm/transfer-stok/detail/' + response.data.data)
                        } else {
                            showToast(response.data.message, 'error');
                        }
                    })
                    .catch(error => {
                        showToast(error.message, 'error');
                    })
            }
        })
    }


    const handleTerima = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin terima data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Ya, Terima'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const send = {
                    mmgudang_id: mmgudangId
                }
                const url = apiUrl.apiUrl + '/mm/transfer-stok/terima-barang/' + row.id
                axios
                    .post(url, send, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.close();
                            showToast(response.data.message, 'success');
                            getTerimaGudang()
                            // navigate('/mm/transfer-stok/detail/' + response.data.data)
                        } else {
                            showToast(response.data.message, 'error');
                        }
                    })
                    .catch(error => {
                        showToast(error.message, 'error');
                    })
            }
        })
    }

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <Divider />
                <TabContext value={tabsDetail}>
                    <TabList
                        scrollButtons
                        variant='fullWidth'
                        onChange={handleChangeTabsDetail}
                        aria-label='forced scroll tabs example'
                    >
                        <Tab value='0' label='Transfer Stock' icon={<Icon icon='mdi:warehouse' />} />
                        <Tab value='1' onClick={getKirimGudang} label={arrGudang.includes(String(mmgudangId)) ? 'Kirim ke Rangkah' : 'Kirim ke 17'} icon={<Icon icon='mdi:file-send' />} />
                        <Tab value='2' onClick={getTerimaGudang} label={arrGudang.includes(String(mmgudangId)) ? 'Terima dari Rangkah' : 'Terima dari 17'} icon={<Icon icon='mdi:file-check' />} />
                    </TabList>
                    <TabPanel value='0'>
                        <Box>
                            <Box
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                </Box>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                                    <Fab color='primary' size='medium' onClick={() => setOpenDialog(true)}>
                                        <Icon icon='mdi:plus' fontSize={35} color='white' />
                                    </Fab>
                                </Box>
                            </Box>
                            <Grid
                                container
                                sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                                spacing={5}
                            >
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label='Tanggal Awal'
                                            type='date'
                                            onChange={(e) => setTglAwal(e.target.value)}
                                            value={tglAwal}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label='Tanggal Akhir'
                                            type='date'
                                            onChange={(e) => setTglAkhir(e.target.value)}
                                            value={tglAkhir}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth>
                                        <Button
                                            variant='contained'
                                            sx={{ mt: 1 }}
                                            startIcon={<Icon icon='mdi:magnify' />}
                                            onClick={() => getData(tabs)}
                                        >
                                            Cari Data
                                        </Button>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <TabContext value={tabs}>
                                <TabList
                                    sx={{ mt: 2, ml: -7 }}
                                    scrollButtons
                                    variant='scrollable'
                                    onChange={handleChangeTabs}
                                    aria-label='forced scroll tabs example'
                                >
                                    <Tab value='0' label='Daftar Transfer Stock' />
                                    {/* <Tab value='1' label='Transfer Stock Belum Aktif' /> */}
                                </TabList>
                                <TabPanel value='0'>
                                    <MsiDatagrid title="Daftar transfer stok" loading={loadingData} array={listData} actions={actionData} />
                                </TabPanel>
                                {/* <TabPanel value='1'>
                                    <MsiDatagrid array={listData} actions={actionData} />
                                </TabPanel> */}
                            </TabContext>
                        </Box>
                    </TabPanel>
                    <TabPanel value='1'>
                        <Box>
                            <Box
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                </Box>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                                    <Fab color='primary' size='medium' onClick={() => setOpenDialogKirim(true)}>
                                        <Icon icon='mdi:plus' fontSize={35} color='white' />
                                    </Fab>
                                </Box>
                            </Box>
                            <CardContent>
                                <Grid
                                    container
                                    sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                                    spacing={5}
                                >
                                    <Grid item xs={12} md={3}>
                                        <FormControl fullWidth>
                                            <TextField
                                                label='Tanggal Awal'
                                                type='date'
                                                onChange={(e) => setTglAwal(e.target.value)}
                                                value={tglAwal}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormControl fullWidth>
                                            <TextField
                                                label='Tanggal Akhir'
                                                type='date'
                                                onChange={(e) => setTglAkhir(e.target.value)}
                                                value={tglAkhir}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        <FormControl fullWidth>
                                            <Button
                                                variant='contained'
                                                sx={{ mt: 1 }}
                                                startIcon={<Icon icon='mdi:magnify' />}
                                                onClick={() => getData(tabs)}
                                            >
                                                Cari Data
                                            </Button>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </CardContent>
                            <MsiDatagrid title="Pengiriman ke gudang" loading={loadingKirim} array={listDataKirim} actions={actionData} />
                        </Box>
                    </TabPanel>
                    <TabPanel value='2'>
                        <MsiDatagrid title="Penerimaan dari gudang" loading={loadingTerima} array={listDataTerima} actions={actionDataTerima} />
                    </TabPanel>
                </TabContext>
            </Grid>
            <Dialog
                maxWidth={'md'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='h6' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Buat Transfer
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valDoctag}
                                        options={listDoctag}
                                        id='doctag'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteDoctag}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Document'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl)}
                                            />
                                        )}
                                    />
                                    {errors.tgl && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valGudang}
                                        options={listGudang}
                                        id='gudang'
                                        readOnly
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        getOptionLabel={(option: any) => option.nama || ""}   // ✅ tampilkan nama
                                        onChange={handleChangeAutocompleteGudang}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Gudang Asal'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valGudangTujuan}
                                        options={listGudang}
                                        id='gudang_tujuan'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        getOptionLabel={(option: any) => option.nama || ""}   // ✅ tampilkan nama
                                        onChange={handleChangeAutocompleteGudangTujuan}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Gudang Tujuan'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='pic'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='PIC'
                                                onChange={onChange}
                                                error={Boolean(errors.pic)}
                                            />
                                        )}
                                    />
                                    {errors.pic && (
                                        <FormHelperText sx={{ color: 'error.main' }}>PIC harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                onChange={onChange}
                                                multiline
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4, gap: 2 }}>
                                        <Button variant='contained' type='submit'>
                                            SIMPAN
                                        </Button>
                                        <Button variant='contained' color='primary' onClick={() => setOpenDialog(false)}>
                                            BATAL
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </form>
            </Dialog>
            <Dialog
                maxWidth={'md'}
                fullWidth={true}
                open={openDialogKirim}
                onClose={() => setOpenDialogKirim(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='h6' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Buat Transfer
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valDoctag}
                                        options={listDoctag}
                                        id='doctag'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteDoctag}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Document'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl)}
                                            />
                                        )}
                                    />
                                    {errors.tgl && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valGudang}
                                        options={listGudang}
                                        id='gudang'
                                        readOnly
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        getOptionLabel={(option: any) => option.nama || ""}   // ✅ tampilkan nama
                                        onChange={handleChangeAutocompleteGudang}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Gudang Asal'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valGudangTujuanKirim}
                                        options={listGudang}
                                        id='gudang_tujuan'
                                        readOnly
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        getOptionLabel={(option: any) => option.nama || ""}   // ✅ tampilkan nama
                                        onChange={handleChangeAutocompleteGudangTujuan}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Gudang Tujuan'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='pic'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='PIC'
                                                onChange={onChange}
                                                error={Boolean(errors.pic)}
                                            />
                                        )}
                                    />
                                    {errors.pic && (
                                        <FormHelperText sx={{ color: 'error.main' }}>PIC harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                onChange={onChange}
                                                multiline
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </form>
            </Dialog>
        </Grid>
    )
}
